import { createSaveInProgressFormReducer } from 'platform/forms/save-in-progress/reducers';
import vapService from '@@vap-svc/reducers';
import { setData } from 'platform/forms-system/src/js/actions';
import { loadCorrectFormConfig } from './helper';

const reducers = {
  'AUG-2025': createSaveInProgressFormReducer(
    loadCorrectFormConfig('AUG-2025'),
  ),
  'OCT-2026': createSaveInProgressFormReducer(
    loadCorrectFormConfig('OCT-2026'),
  ),
};

const getPdfVersion = data =>
  data?.pdfVersion?.includes('2026') ? 'OCT-2026' : 'AUG-2025';
const form = (state, action) => {
  const currentPdfVersion = getPdfVersion(state?.data);
  const nextState = reducers?.[currentPdfVersion](state, action);
  const nextPdfVersion = getPdfVersion(nextState?.data);

  if (nextPdfVersion === currentPdfVersion) {
    return nextState;
  }
  const reducer = reducers?.[nextPdfVersion];
  const initialState = reducer(undefined, { type: '@@INIT' });
  return reducer(
    {
      ...initialState,
      ...nextState,
      pages: initialState.pages,
      initialData: initialState.initialData,
    },
    setData(nextState.data),
  );
};

export default { form, vapService };
